module.exports = __webpack_public_path__ + "img/20190601135451652.330f02e4.png";